import { render, staticRenderFns } from "./foodsafety.vue?vue&type=template&id=057866a0&scoped=true"
var script = {}
import style0 from "./foodsafety.vue?vue&type=style&index=0&id=057866a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057866a0",
  null
  
)

export default component.exports